import compact from 'lodash/compact';

// eslint-disable-next-line import/prefer-default-export
export function toFullName({ firstName, lastName }) {
  return compact([firstName, lastName]).join(' ');
}
